module.exports = __webpack_public_path__ + "img/thumb_07.c4902609.jpg";